<div
	class="gabby-message-participant-label"
	[ngClass]="'gabby-participant-label-' + getParticipantLabelType()"
>
	{{ getParticipantLabelType() }}
</div>
